import { useState } from "react";
import useValidator from "../../../hooks/useValidator";
import { toast } from "react-toastify";
import { httprequest } from "../../../data/api";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { Grid } from "@mui/material";

const SESSION_ENDPOINT = "/api/v1/school-plan/session";

const index = ({ isOpen, onClose, onSuccess }) => {
  const [sessionValidator, showSessionValidator] = useValidator();
  //   const [addSessionModal, setAddSessionModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [sessionForm, setSessionForm] = useState({
    session: "",
    start_date: "",
    end_date: ""
    // is_current: false
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSessionForm({ ...sessionForm, [name]: value });
  };

  //   const handleAddSessionModal = () => {
  //     setAddSessionModal(!addSessionModal);
  //   };

  const handleCloseSessionModal = () => {
    onClose();
  };

  const handleCreateSession = () => {
    if (sessionValidator.allValid()) {
      setIsLoading(true);
      httprequest.post(SESSION_ENDPOINT, sessionForm).then((res) => {
        setIsLoading(false);

        const toastId = toast.success(res?.data?.message, {
          autoClose: 3000
        });

        setTimeout(() => {
          toast.dismiss(toastId);
          if (onSuccess) onSuccess();
          // window.location.reload();
        }, 3000);

        setSessionForm({ ...sessionForm, session: "", start_date: "", end_date: "" });
        handleCloseSessionModal();
      }).catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showSessionValidator(true);
    }
  };

  const { session, start_date, end_date } = sessionForm;

  return (
    <div>
      <Modal
        title="Create Session"
        subtitle="Better manage your school sessions by creating one"
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup required inputName="session" type="text" label="Session Name" placeholder="e.g 2021/2022" value={session}
                  onChange={handleChange}
                />
                {sessionValidator.message("Session", session, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup required inputName="start_date" inputType="date" label="Start Date" value={start_date} onChange={handleChange} />
                {sessionValidator.message("Start Date", start_date, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup required inputName="end_date" inputType="date" label="End Date" value={end_date} onChange={handleChange} />
                {sessionValidator.message("Start Date", end_date, "required")}
              </Grid>
              {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <input type="checkbox" name="is_current" id="current_term" onChange={handleIsCurrent} />
                    <label className="checkbox-label" for="current_term">Current Session</label>
                  </Grid> */}

            </Grid>
          </>
        }
        modalFooter={
          <>
            <Button
              type="submit"
              onClick={handleCreateSession}
              variant="primary"
              buttonName="Create New Session"
              buttonSize="full"
              color="btndefault"
              isLoading={isLoading}
            />
          </>
        }
        isopen={isOpen}
        closeModal={handleCloseSessionModal}
      />
    </div>
  );
};

export default index;
